import * as React from 'react';
import { useState, useEffect } from 'react';

import { getAuth, onAuthStateChanged} from 'firebase/auth';
import { app, db } from './../firebase-config';
import { collection, getDoc, addDoc, doc, updateDoc, onSnapshot } from 'firebase/firestore';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Button from '@mui/material/Button';
import HeaderBack from './common/HeaderBack';

import { useNavigate } from 'react-router-dom';
import CameraAltRoundedIcon from '@mui/icons-material/CameraAltRounded';

export default function BasicTextFields({title}){
	const [userK, setUserK] = useState({});
	
	const [name, setName] = useState('');
	const [meowName, setMeowName] = useState('');
	const [bio, setBio] = useState('');
	const [location, setLocation] = useState('');
	const [website, setWebsite] = useState('');
	
	const userCollectionRef = collection(db, "users");
	
	let navigate = useNavigate();
	
	useEffect(() => {
		
		const auth = getAuth();	
		
		setUserK(auth.currentUser)
		
			if(userK != null){
					
				const createmeow = async () => {
				
				const unsub = onSnapshot(doc(db, "users", userK.uid), (doc) => {
					
					setName(doc.data().name)
					setMeowName(doc.data().meowName)
					setBio(doc.data().bio)
					setLocation(doc.data().location)
					setWebsite(doc.data().website)
					});
				}
				createmeow();
				};
		
		let authToken = sessionStorage.getItem("Auth Token");
		
		if(authToken){
			navigate('/editprofile')
		}
		
		if(!authToken){
			navigate('/')
		}
	}, [userK])
	
	const handleSave = (e) => {
		try{
			e.preventDefault();
			
			const auth = getAuth();
			
			onAuthStateChanged(auth, (user) => {
				
				if(user){
					
					setUserK(user);
					
					const userProfile = updateDoc(doc(db, "users", user.uid), {
					name: name,
					meowName: meowName,
					bio: bio,
					location: location,
					website: website,
					})
					console.log(user.uid);
				}
				
			});
			
			alert('Saved');
		}catch(e) {
		console.log("error adding doc:", e);
		alert('Changes not added');
		}
	}
	
	return(
	<>	
		<HeaderBack titleHead={"Edit Profile"}/>
		<section className="input-image-header">
			<input type="file" accept="image/*" className="edit-img-full" id="upload" hidden/>
			<label htmlFor="upload" ><CameraAltRoundedIcon /></label>
		</section>
		
			<section className="profile-image-edit-sec">
				<div className="input-img-dp">
					<input type="file" accept="image/*" id="upload" hidden/>
					<label htmlFor="upload" ><CameraAltRoundedIcon /></label>
				</div>
			</section>
		
		<section className="profile-edit-form" >
			
			<Box
				component='form'
				sx={{
					'&>:not(style)':{ mb:2},
				}}
				noValidate
				autoComplete="off"
			>

				
				<TextField id="name" label="Name" value={name} focused variant="outlined"  style={{width: '100%'}} onChange={(e) => setName(e.target.value)}/>
				<TextField id="name" label="MeowName" value={meowName} focused variant="outlined"  style={{width: '100%'}} onChange={(e) => setMeowName(e.target.value)}/>
				<TextField
				multiline
				label="Bio"
				value={bio}
				focused
				style={{ width: '100%'}}
				onChange={(e) => setBio(e.target.value)}
				/>


				<TextField id="location" label="Location" value={location} variant="outlined" focused style={{width: '100%'}} onChange={(e) => setLocation(e.target.value)}/>
				<TextField id="website" label="Website" value={website} variant="outlined" focused style={{width: '100%'}} onChange={(e) => {console.log(e.target.value);setWebsite(e.target.value)}}/>
			</Box>
			
			<Button  variant="contained"  sx={{width: "100%", mt:"2rem", p: "0.8rem"}} onClick={handleSave} >Save</Button>

		</section>
	</>
	);
}